import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  TrackByFunction,
} from '@angular/core';

import { trackByProp, trackByValue } from '@recruitee/common';
import {
  HeadingComponent,
  DropdownItemComponent,
  DropdownHeaderComponent,
  DropdownComponent,
} from '@recruitee/user-interface';

import { InsertPlaceholderInputDirective } from '../insert-placeholder-input.directive';
import { InsertPlaceholderDirective } from '../insert-placeholder.directive';
import { Placeholder, PlaceholderCategory, PlaceholderId } from '../placeholder';
import { PlaceholderSelectDropdownComponent } from '../placeholder-select-dropdown/placeholder-select-dropdown.component';
import { PlaceholderService } from '../placeholder.service';

@Component({
  selector: 'rt-placeholder-category-select-dropdown',
  templateUrl: './placeholder-category-select-dropdown.component.html',
  styleUrls: ['./placeholder-category-select-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    DropdownComponent,
    DropdownHeaderComponent,
    DropdownItemComponent,
    HeadingComponent,
    InsertPlaceholderDirective,
    NgTemplateOutlet,
    PlaceholderSelectDropdownComponent,
  ],
})
export class PlaceholderCategorySelectDropdownComponent {
  @Input() public active: Placeholder;
  @Input() public activeTarget: InsertPlaceholderInputDirective | undefined;
  @Input() public placeholders: Placeholder[];
  @Input() public customNoCategoryPlaceholdersCollection: PlaceholderId[];
  @Input() public customCategories: PlaceholderCategory[];
  @Input() public selectFooterTemplate: TemplateRef<any>;
  @Input() public header: string;

  @Output() public select: EventEmitter<Placeholder> = new EventEmitter();

  public selectedCategory: PlaceholderCategory | string = '';
  public categories: PlaceholderCategory[];
  public trackByCategoryName = trackByValue;
  public trackByPlaceholderName: TrackByFunction<Placeholder> = trackByProp<Placeholder>({
    prop: 'id',
  });
  public noCategoryPlaceholders: Placeholder[];
  public noCategoryPlaceholdersCollection = [
    PlaceholderId.Company,
    PlaceholderId.Department,
    PlaceholderId.JobOffer,
    PlaceholderId.JobOfferAll,
  ];

  public placeholderCategoryTranslationMap =
    this.placeholderService.placeholderCategoryTranslationMap;

  constructor(
    private cdRef: ChangeDetectorRef,
    private placeholderService: PlaceholderService,
  ) {}

  public ngOnInit() {
    this.categories =
      this.customCategories ||
      Object.values(PlaceholderCategory).filter(category =>
        this.placeholderService.isCategoryVisible(this.placeholders, category),
      );

    this.noCategoryPlaceholders = (
      this.customNoCategoryPlaceholdersCollection || this.noCategoryPlaceholdersCollection
    ).flatMap(placeholderId =>
      this.placeholderService.filterPlaceholders(this.placeholders, placeholderId),
    );
  }

  public setCategory(category: PlaceholderCategory | string = '', event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.selectedCategory = category;
    this.cdRef.detectChanges();
  }

  public withoutBrackets(str: string): string {
    return str.slice(1, -1);
  }
}
